import {ReactEChartsProps} from "../../../../components/charts/ReactECharts";
import {ChartResults} from "../../../../actions/queryBuilderApi";

export const BaseBarChartOption: ReactEChartsProps["option"] = {
    tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
            const item = Array.isArray(params) ? params[0] : params;
            return `${item.marker} <strong>${item.name}</strong>: ${item.value}`;
        },
        axisPointer: {
            type: 'shadow'
        }
    },
    legend: {
        orient: 'horizontal',
        type: 'scroll',
        bottom: 0,
    },
    grid: {
        containLabel: true,
        left: 0,
        right: 0
    },
    xAxis: {
        type: 'category',
        axisLabel: {
            show: false
        }
    },
    yAxis: {
        type: 'value',
    }
}

export const barChartOption = (chartData: ChartResults): ReactEChartsProps["option"] => {
    const isSingleSeries = chartData.values.length === 1 && chartData.labels.length > 0
    let seriesConfig
    if (isSingleSeries) {
        const singleSeriesData = chartData.values[0].data
        seriesConfig = chartData.labels.map((label, index) => ({
            type: 'bar',
            name: label,
            data: [singleSeriesData[index]],
            barGap: '-100%',
            barWidth: '50%',
        }))
    } else {
        seriesConfig = chartData.values.map(value => ({
            type: 'bar',
            name: value.name,
            data: value.data,
        }))
    }
    return {
        ...BaseBarChartOption,
        xAxis: {
            ...(BaseBarChartOption.xAxis as object),
            data: chartData.labels
        },
        series: seriesConfig
    } as ReactEChartsProps["option"]

}